module.exports = __webpack_public_path__ + "img/ContactBook.eae13b66.svg";